import request from "@/util/http";
/**
 * 检查用户名是否存在
 */
export function check_username(query) {
	return request({
		url: '/upms/shop/register/check_username',
		method: 'get',
		params: query,
	})
}


/**
 * 检查E-mail是否存在
 */
export function check_email(query) {
	return request({
		url: '/upms/shop/register/check_email',
		method: 'get',
		params: query,
	})
}


/**
 * 检查手机是否存在
 */
export function check_mobile(query) {
	return request({
		url: '/upms/shop/register/check_mobile',
		method: 'get',
		params: query,
	})
}

/**
 * 注册页面
 */
export function index(query) {
	return request({
		url: '/upms/shop/register',
		method: 'get',
		params: query,
	})
}

/**
 * 注册提交（游客接口，不得携带旧会员 Bearer）
 */
export function submit(params) {
	return request({
		url: '/upms/shop/register/submit',
		method: 'post',
		params: params,
		headers: { isToken: false },
	})
}

/**
 * 发送邮箱注册验证码
 */
export function send_email_code(params) {
	return request({
		url: '/upms/shop/register/email_code',
		method: 'post',
		params: params,
	})
}

/**
 * 邮箱注册提交（游客接口，不得携带旧会员 Bearer）
 */
export function email_submit(params) {
	return request({
		url: '/upms/shop/register/email_submit',
		method: 'post',
		params: params,
		headers: { isToken: false },
	})
}


// module.exports = {
// 	check_username,
// 	check_email,
// 	check_mobile,
// 	index,
// 	submit,
// }
